/** 👇 Chart */
const ChartRefactor = () =>
  import(/* webpackChunkName: "chart" */ '../views/ChartRefactor.vue')

const ChartRoute = [
  {
    path: '/chart',
    name: 'chart',
    component: ChartRefactor,
    // meta: {
    //   requiresAuth: true,
    //   hiddeMenu: true,
    //   navBar: true,
    //   navBarBack: true,
    //   title: 'Chart',
    //   backLink: 'analysis',
    // },
  },
]

export default ChartRoute
